import { Box, Checkbox, Icon, Label, LabeledControl, Text } from '@zillow/constellation-10';
import { IconPhotosOutline } from '@zillow/constellation-icons';
import { AttachmentIcon } from '@zg-rentals/satellite-components';
import { useContext } from 'react';
import Image from 'next/image';
import { AppContext } from '../../../../../contexts/AppContextProvider';
import type { HandleSelectAttachmentToDelete } from '../../index';
import { truncatedTextStyles } from '../../../../../styles/text';

type AttachmentCardSelectorProps = {
  fileName: string;
  fileType: string;
  imageSrc: string;
  onSelect: HandleSelectAttachmentToDelete;
  zDocId: string;
};

export default function AttachmentCardSelector({
  fileName,
  fileType,
  imageSrc,
  onSelect,
  zDocId,
}: AttachmentCardSelectorProps) {
  const { isImpersonator } = useContext(AppContext);
  const isZDocPreviewUrl = imageSrc.includes('zillowdocs') && imageSrc?.includes('/image/preview');
  const imageSrcResized = isZDocPreviewUrl ? `${imageSrc}&height=${24}&width=${32}` : imageSrc;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSelect(e.target.value, e.target.checked);
  };

  return (
    <LabeledControl
      css={{
        alignItems: 'center',
        background: 'gray.100',
        border: '1px solid',
        borderColor: 'gray.300',
        borderRadius: 'md',
        display: 'flex',
        marginTop: 'tighter',
        overflowX: 'hidden',
        paddingLeft: 'tighter',
        paddingRight: 'tighter',
        '& input[type="checkbox"]': { marginBlockStart: 0 },
      }}
      control={<Checkbox value={zDocId} onChange={handleChange} css={{ marginBlockStart: 0 }} />}
      label={
        <Label css={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          {imageSrcResized ? (
            <>
              {isImpersonator ? (
                <Box
                  css={{
                    alignItems: 'center',
                    backgroundColor: 'gray.200',
                    borderRadius: 'sm',
                    display: 'flex',
                    height: '24px',
                    minWidth: '32px',
                    width: '32px',
                  }}
                >
                  <Icon css={{ color: 'gray.400' }}>
                    <IconPhotosOutline />
                  </Icon>
                </Box>
              ) : (
                <Image
                  src={imageSrcResized}
                  width={32}
                  height={24}
                  alt="Image thumbnail in delete attachment modal"
                  style={{
                    borderRadius: '4px',
                    objectFit: 'cover',
                    width: '32px',
                    minWidth: '32px',
                    height: '24px',
                  }}
                />
              )}
            </>
          ) : (
            <AttachmentIcon fileType={fileType} />
          )}
          <Text
            textStyle="body-sm"
            css={{ ...truncatedTextStyles, maxWidth: '100%', marginLeft: 'default', marginRight: 'default' }}
          >
            {fileName}
          </Text>
        </Label>
      }
    />
  );
}
